





















































































































































































































































































import { storeDokter } from "@/store/modules/dokter";
import { Component, Vue, Prop } from "vue-property-decorator";
import AsesmenAwalRanapMedis from "@/services/AsesmenAwalRanapMedis";
import { appModule } from "@/store/modules/app";
import AsesmenAwalRanapMedisStore from "@/store/modules/AsesmenAwalRanapMedisStore";
import AsesmenMedisIgdStore from "@/store/modules/AsesmenMedisIgdStore";
import SurveyPrimerIgdStore from "@/store/modules/SurveyPrimerIgdStore";
import { storePenunjang } from "@/store/modules/penunjang";

@Component
export default class AsesmenRanapMedisIgdPage extends Vue {
  @Prop() readonly register!: number;
  @Prop() readonly rm!: number;

  saving = false;

  examinedAt = null;
  keluhanUtama = null;
  riwayatPenyakitSekarang = null;
  riwayatPenyakitDahulu = null;
  riwayatPenyakitKeluarga = null;
  keadaanUmum = null;
  suhu = null;
  nadi = null;
  nafas = null;
  tensi = null;
  bb = null;
  tb = null;
  bbl = null;

  kepala = "";
  leher = "";
  dada = "";
  jantung = "";
  paru = "";
  perut = "";
  ekstremitasAtas = "";
  ekstremitasBawah = "";
  statusPubertas = "";

  lab = null;
  radiologi = null;

  diagnosis = null;

  terapi = null;

  dokter = null;

  get listDokter() {
    return storeDokter.list;
  }

  get asesmenRanapData() {
    return this.asesmenRanapStore.asesmen;
  }

  get asesmenRanapStore() {
    return AsesmenAwalRanapMedisStore;
  }

  get asesmenAwal() {
    return AsesmenMedisIgdStore;
  }

  get asesAwalContent() {
    return this.asesmenAwal.asesmen?.content;
  }

  get surveyPrimer() {
    return SurveyPrimerIgdStore.asesmen;
  }

  get orderLab() {
    return storePenunjang.listorderLab
      .filter((item) => item.status == 1)
      .map(({ items }) => items.map(({ name }) => name))
      .flat();
  }

  get orderRadiologi() {
    return storePenunjang.listorderRadiologi
      .filter((item) => item.status == 1)
      .map(({ items }) => items.map(({ name }) => name))
      .flat();
  }

  get input() {
    return {
      pasien_rm: this.rm,
      register_id: this.register,
      unit_id: "01",
      content: {
        examinedAt: this.examinedAt,
        keluhanUtama: this.keluhanUtama,
        riwayatPenyakitSekarang: this.riwayatPenyakitSekarang,
        riwayatPenyakitDahulu: this.riwayatPenyakitDahulu,
        riwayatPenyakitKeluarga: this.riwayatPenyakitKeluarga,
        keadaanUmum: this.keadaanUmum,
        suhu: this.suhu,
        nadi: this.nadi,
        nafas: this.nafas,
        tensi: this.tensi,
        bb: this.bb,
        tb: this.tb,
        bbl: this.bbl,

        kepala: this.kepala,
        leher: this.leher,
        dada: this.dada,
        jantung: this.jantung,
        paru: this.paru,
        perut: this.perut,
        ekstremitasAtas: this.ekstremitasAtas,
        ekstremitasBawah: this.ekstremitasBawah,
        statusPubertas: this.statusPubertas,

        lab: this.lab,
        radiologi: this.radiologi,

        diagnosis: this.diagnosis,

        terapi: this.terapi,

        dokter: this.dokter,
      },
      signee_id: 268,
      user_id: 268,
    };
  }

  get showGetTandaVitalButton() {
    return this.surveyPrimer?.content?.tanda_vital;
  }

  get showGetAnamnesisButton() {
    return this.asesAwalContent?.anamnesis;
  }

  get showGetFisikButton() {
    return this.asesAwalContent?.fisik;
  }

  get showGetPenunjangButton() {
    return this.orderLab.length || this.orderRadiologi.length;
  }

  insertAnamnesis() {
    this.keluhanUtama = this.asesAwalContent.anamnesis.keluhanUtama;
    this.riwayatPenyakitSekarang =
      this.asesAwalContent.anamnesis.riwayatPenyakitSekarang;
    this.riwayatPenyakitDahulu =
      this.asesAwalContent.anamnesis.riwayatPenyakitDahulu;
  }

  insertTandaVital() {
    this.suhu = this.surveyPrimer.content.tanda_vital.suhu;
    this.tensi = this.surveyPrimer.content.tanda_vital.tensi;
    this.nadi = this.surveyPrimer.content.tanda_vital.nadi;
    this.nafas = this.surveyPrimer.content.tanda_vital.nafas;
    this.bb = this.surveyPrimer.content.tanda_vital.bb;
    this.tb = this.surveyPrimer.content.tanda_vital.tb;
  }

  insertFisik() {
    this.kepala = this.asesAwalContent.fisik.kepala;
    this.leher = this.asesAwalContent.fisik.leher;
    this.dada = this.asesAwalContent.fisik.dada;
    this.paru = this.asesAwalContent.fisik.paru;
    this.jantung = this.asesAwalContent.fisik.jantung;
    this.perut = this.asesAwalContent.fisik.perut;
    this.ekstremitasAtas = this.asesAwalContent.fisik.ektrimitaAtas;
    this.ekstremitasBawah = this.asesAwalContent.fisik.ektrimitaBawah;
  }

  insertDiagTerapi() {
    this.diagnosis =
      this.asesAwalContent.diagnosis.kerja +
      ". " +
      this.asesAwalContent.diagnosis.tambahan;
    this.terapi = this.asesAwalContent.terapi.terapi;
  }

  insertLabRadiologi() {
    this.lab = this.orderLab.join("; ");
    this.radiologi = this.orderRadiologi.join("; ");
  }

  addDbn(field) {
    if (!this[field]) {
      this[field] = this[field].concat(" Dalam batas normal").trim();
    } else {
      alert(
        "Mohon hapus isian sebelumnya terlebih dahulu untuk menetapkan ini sebagai DBN"
      );
    }
  }

  save() {
    if (!this.saving) {
      this.saving = true;

      const sendRequest = this.asesmenRanapData
        ? AsesmenAwalRanapMedis.update(this.asesmenRanapData.id, this.input)
        : AsesmenAwalRanapMedis.create(this.input);

      sendRequest
        .then(() => {
          // set store module

          appModule.NoticeDelay("Berhasil Simpan Asesmen Medis");

          this.getByRegister();
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  getByRegister() {
    AsesmenAwalRanapMedisStore.getByRegister(this.register).then(() => {
      // const data = this.asesmenRanapData,
      //   content = data.content;
    });
  }
}
